/**
 * Club Ten — shared scroll-reveal engine.
 * Replicates framer-motion `whileInView` fade/slide/scale reveals using
 * IntersectionObserver + CSS transitions (see ct-base.css .ct-reveal).
 * Any element with [data-ct-reveal] gets `.is-visible` added once it
 * crosses the viewport threshold; supports stagger via data-ct-delay (ms).
 */
(function () {
  if (window.__ctRevealInit) return;
  window.__ctRevealInit = true;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = parseInt(el.dataset.ctDelay || '0', 10);
          setTimeout(() => el.classList.add('is-visible'), delay);
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  function register(root) {
    root.querySelectorAll('[data-ct-reveal]').forEach((el) => observer.observe(el));
  }

  /**
   * Splits heading text into per-character <span>s for a stagger-in reveal.
   * Shopify wraps translatable settings in HTML comments (`BEGIN SETTING`);
   * Comment.textContent is the marker, so comments must be skipped.
   */
  function visibleText(node) {
    if (!node || node.nodeType === Node.COMMENT_NODE) return '';
    if (node.nodeName === 'BR') return '\n';
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.replace(/(?:BEGIN|END)\s+SETTING:\s*\S+/gi, '');
    }
    return Array.from(node.childNodes).map(visibleText).join('');
  }

  function splitChars(root) {
    root.querySelectorAll('[data-ct-chars]').forEach((el) => {
      if (el.dataset.ctCharsDone) return;
      const lines = visibleText(el).split('\n').map((line) => line.replace(/\s+/g, ' ').trim());
      while (lines.length && !lines[0]) lines.shift();
      while (lines.length && !lines[lines.length - 1]) lines.pop();
      el.textContent = '';
      let i = 0;

      lines.forEach((line, lineIdx) => {
        const words = line.split(' ');
        words.forEach((word, wIdx) => {
          if (!word) return;
          const wordSpan = document.createElement('span');
          wordSpan.style.display = 'inline-block';
          wordSpan.style.whiteSpace = 'nowrap';
          Array.from(word).forEach((ch) => {
            const charSpan = document.createElement('span');
            charSpan.textContent = ch;
            charSpan.className = 'ct-char';
            charSpan.style.transitionDelay = (i * 25) + 'ms';
            wordSpan.appendChild(charSpan);
            i++;
          });
          el.appendChild(wordSpan);
          if (wIdx !== words.length - 1) {
            const space = document.createElement('span');
            space.style.display = 'inline-block';
            space.innerHTML = '&nbsp;';
            el.appendChild(space);
          }
        });
        if (lineIdx !== lines.length - 1) el.appendChild(document.createElement('br'));
      });

      el.dataset.ctCharsDone = 'true';

      const charObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              charObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      charObserver.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    register(document);
    splitChars(document);
  });
  document.addEventListener('shopify:section:load', (e) => splitChars(e.target));

  // Re-scan when Shopify section editor re-renders a section
  document.addEventListener('shopify:section:load', (e) => register(e.target));
})();
